import { render, staticRenderFns } from "./FiltroAnexos.vue?vue&type=template&id=2379e8a2&scoped=true"
import script from "./FiltroAnexos.vue?vue&type=script&lang=js"
export * from "./FiltroAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379e8a2",
  null
  
)

export default component.exports